import React, { Component } from 'react';

class InputField extends Component{
    render(){
        const {value,onChangeHandler,placeholder,name,autoComplete,className, id=''} = this.props;
        return <input type="text" id={id} name={name} className={className} placeholder={placeholder} value={value}  onChange={onChangeHandler} autoComplete={autoComplete?"off":""}/>
    }
}

export default InputField;